/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AboutEstateInfo } from '../models/AboutEstateInfo';
import type { EconomyInfo } from '../models/EconomyInfo';
import type { GeneralInfo } from '../models/GeneralInfo';
import type { HomeAssignmentLoan } from '../models/HomeAssignmentLoan';
import type { MaintenanceAndRebuilding } from '../models/MaintenanceAndRebuilding';
import type { MyPagesValueCheckFormViewModel } from '../models/MyPagesValueCheckFormViewModel';
import type { Purchase } from '../models/Purchase';
import type { QuestionList } from '../models/QuestionList';
import type { Sale } from '../models/Sale';
import type { Settlement } from '../models/Settlement';
import type { SurroundingInfo } from '../models/SurroundingInfo';
import type { Suspension } from '../models/Suspension';
import type { TechnicalInfo } from '../models/TechnicalInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MyPagesService {

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetDeclarationBasisDates(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetDates',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveSale(
        sessionId?: string,
        estateId?: string,
        requestBody?: Sale,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/DeclarationBasis/SaveSale',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetSale(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetSale',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSavePurchase(
        sessionId?: string,
        estateId?: string,
        requestBody?: Purchase,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/DeclarationBasis/SavePurchase',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetPurchase(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetPurchase',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveSettlement(
        sessionId?: string,
        estateId?: string,
        requestBody?: Settlement,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/DeclarationBasis/SaveSettlement',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetSettlement(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetSettlement',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveMaintenanceAndRebuilding(
        sessionId?: string,
        estateId?: string,
        requestBody?: MaintenanceAndRebuilding,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/DeclarationBasis/SaveMaintenanceAndRebuilding',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetMaintenanceAndRebuilding(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetMaintenanceAndRebuilding',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveSuspension(
        sessionId?: string,
        estateId?: string,
        requestBody?: Suspension,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/DeclarationBasis/SaveSuspension',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetSuspension(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/DeclarationBasis/GetSuspension',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendDeclarationBasis(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/SendDeclarationBasis',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetQuestionList(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/GetQuestionList',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveQuestionList(
        sessionId?: string,
        estateId?: string,
        requestBody?: QuestionList,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/SaveQuestionList',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendQuestionList(
        sessionId?: string,
        estateId?: string,
        requestBody?: QuestionList,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/SendQuestionList',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentDates(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetDates',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentGeneralInfo(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetGeneralInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveGeneralInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: GeneralInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SaveGeneralInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendGeneralInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: GeneralInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendGeneralInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendLoanInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: HomeAssignmentLoan,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendLoanInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentEconomyInfo(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetEconomyInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveEconomyInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: EconomyInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SaveEconomyInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendEconomyInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: EconomyInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendEconomyInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentAboutEstateInfo(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetAboutEstateInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveAboutEstateInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: AboutEstateInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SaveAboutEstateInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendAboutEstateInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: AboutEstateInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendAboutEstateInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentSurroundingInfo(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetSurroundingInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveSurroundingInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: SurroundingInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SaveSurroundingInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendSurroundingInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: SurroundingInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendSurroundingInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetHomeAssignmentTechnicalInfo(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/HomeAssignment/GetTechnicalInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSaveTechnicalInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: TechnicalInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SaveTechnicalInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSendTechnicalInfo(
        sessionId?: string,
        estateId?: string,
        requestBody?: TechnicalInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/HomeAssignment/SendTechnicalInfo',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetToDoDates(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/GetToDoDates',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param customerId
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetEstateValuationWithContactId(
        customerId?: string,
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/GetEstateValuationWithContactId',
            query: {
                'customerId': customerId,
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param testId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetEstateValuationJson(
        sessionId?: string,
        estateId?: string,
        testId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/GetEstateValuationJson',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
                'testId': testId,
            },
        });
    }

    /**
     * @param sessionId
     * @param testId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesGetEstateValuation(
        sessionId?: string,
        testId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MyPages/GetEstateValuation',
            query: {
                'sessionId': sessionId,
                'testId': testId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesUnsubscribeValueCheck(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/UnsubscribeValueCheck',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesSignUpValuation(
        sessionId?: string,
        requestBody?: MyPagesValueCheckFormViewModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/SignUpValuation',
            query: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static myPagesUploadFile(
        sessionId?: string,
        estateId?: string,
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MyPages/UploadFile',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
